"use client"

import Script from "next/script"

import { PSEUDO_ID_COOKIE } from "@/platform/api/constants"
import { AUTH_URL_CREDENTIAL_PARAMS } from "@/platform/api/redact-auth-url"
import { getSessionCookie } from "@/platform/session/auth/get-session-cookie-client"

export const GaCustomAnalytics = ({ gaId }: { gaId: string }) => {
  const appVersion = process.env.NEXT_PUBLIC_APP_VERSION || "local"

  const configParams: Record<string, string> = {
    source: "store_front",
    version: appVersion,
  }

  const pseudoId = getSessionCookie(PSEUDO_ID_COOKIE)
  if (pseudoId) {
    configParams.storefront_session_id = pseudoId
  }

  const configParamsStr = JSON.stringify(configParams)

  return (
    <>
      <Script async src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`} />
      <Script id="_next-ga-init">
        {`
          window['dataLayer'] = window['dataLayer'] || [];
          function gtag(){window['dataLayer'].push(arguments);}
          gtag('js', new Date());
          
          const neloPageLocation = new URL(window.location.href);
          ${JSON.stringify(AUTH_URL_CREDENTIAL_PARAMS)}.forEach((key) => neloPageLocation.searchParams.delete(key));
          gtag('config', '${gaId}', { ...${configParamsStr}, page_location: neloPageLocation.href });
        `}
      </Script>
    </>
  )
}
